export default "__VITE_ASSET__CQeR5N$O__"